import React from 'react';
import { FadeIn } from '../ui/BasicUI';

export function Finale() {
  return (
    <section className="scene finale" data-yuga="kali" data-chapter="The Wheel Turns">
      <div className="embers" aria-hidden="true">
        {Array.from({ length: 24 }).map((_, i) => (
          <span key={i} className="ember" style={{
            left: `${(i * 4.3) % 100}%`,
            animationDelay: `${(i * 0.7) % 16}s`,
            animationDuration: `${10 + (i % 6) * 2}s`,
            background: i % 3 === 0 ? "var(--treta-glow)" : "var(--paper-dim)",
          }} />
        ))}
      </div>
      <div className="stage center-stack">
        <FadeIn>
          <p className="eyebrow" style={{ letterSpacing: "0.5em" }}>now · here · the age you are reading this in</p>
        </FadeIn>
        <FadeIn delay={300}>
          <div style={{ fontFamily: "var(--deva)", fontSize: "clamp(56px, 8vw, 110px)", color: "var(--paper)", textShadow: "0 0 40px rgba(106,96,88,0.6)", lineHeight: 1, margin: "20px 0" }}>
            कलि युग
          </div>
        </FadeIn>
        <FadeIn delay={600}>
          <p className="closing">
            The lamps have grown faint.<br/>
            Truth, they say, walks on one leg now.<br/>
            <i>And yet, the wheel keeps turning.</i>
          </p>
        </FadeIn>
        <FadeIn delay={1100}>
          <p className="listen">listen for the hoofbeats · कल्कि is coming</p>
        </FadeIn>
      </div>
    </section>
  );
}
